import { render, staticRenderFns } from "./charityReport.vue?vue&type=template&id=0d997535&"
import script from "./charityReport.vue?vue&type=script&lang=js&"
export * from "./charityReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports